const calcBMI = (heightFt, heightIn, weight) => {
    const height = (parseInt(heightFt) * 12) + parseInt(heightIn);
    const bmi = 703 * (weight / (height ** 2));
    return Math.round(bmi);
}

export default calcBMI;